import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConnectionService } from '../../../services/connection/connection.service';
import { LoggerService } from '../../../services/logger/logger.service';
import { PricelistService } from './pricelist.service';
import { ProductPricelist } from '../models/product-pricelist';

@Injectable()
export class PricelistOdooService implements PricelistService {

  constructor(
    private connectionService: ConnectionService,
    private logger: LoggerService,
  ) { }

  getPricelistById(pricelistId: number): Observable<ProductPricelist> {
    return this.connectionService.sendJsonPostRequest('/store/payment/get_pricelist_by_id', {
      pricelistId: pricelistId,
    }).pipe(map(
      result => {
        return result ? ProductPricelist.createFromAny(result) : null;
      }));
  }

  getDefaultPricelist(): Observable<ProductPricelist> {
    return this.connectionService.sendJsonPostRequest('/store/payment/get_default_pricelist', {})
      .pipe(
        map(result => {
          return result ? ProductPricelist.createFromAny(result) : null;
        }),
        catchError(error => {
          return of(null);
        }),
      );
  }
}
